import React from 'react';
import { Container, CssBaseline, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { OperHeaderBar } from '../../header/HeaderBar';
import { OperSideHeader } from '../../header/SideHeader';

const useStyles = makeStyles((theme) => ({
	background: {
		width: '100%',
		height: '100vh',
		display: 'flex',
		background: '#fff',
	},
	sideHeaderWrapper: {
		height: '100%',
		overflowY: 'auto',
	},
	contentWrapper: {
		width: '100%',
		height: '100%',
		flex: '1',
		overflowY: 'auto',
	},
	container: {
		width: '100%',
		height: 'calc(100vh - 12vh)',
		[theme.breakpoints.up('md')]: {
			marginTop: '0px',
			height: '100%',
		},
	},
}));

interface OperationLayoutProps {
	children: React.ReactNode;
	oper: any;
}

const OperationLayout: React.FC<OperationLayoutProps> = ({ children, oper }) => {
	const classes = useStyles();
	const theme = useTheme();
	const isTablet = useMediaQuery(theme.breakpoints.up('md'));
	if (!children) {
		return null;
	}
	return (
		<>
			<CssBaseline />
			{isTablet ? (
				<div className={classes.background}>
					<div className={classes.sideHeaderWrapper}>
						<OperSideHeader oper={oper} />
					</div>
					<div className={classes.contentWrapper}>
						<Container component="main" className={classes.container} disableGutters>
							{children}
						</Container>
					</div>
				</div>
			) : (
				<>
					<OperHeaderBar oper={oper} />
					<Container component="main" className={classes.container} disableGutters={true}>
						{children}
					</Container>
				</>
			)}
		</>
	);
};

export default OperationLayout;
